import * as R from 'ramda';
import angular from 'angular';

export default function SyncControlTypeDialogController(
  $q,
  $rootScope,
  $scope,
  ssDialogService,
  confirmDialog,
  alerts,
  controlDataService,
  loaderService, // eslint-disable-line no-unused-vars
  syncControlConfirmDialog,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSyncControls = _handleSyncControls;
  vm.handleCheckAllChange = _handleCheckAllChange;
  vm.isEditable = true;
  vm.handleClearFilters = _handleClearFilters;
  vm.showFilters = true;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    vm.searchText = '';
    vm.controls = [];
    if (vm.controlType.customerControls && vm.controlType.customerControls.length > 0) {
      angular.forEach(vm.controlType.customerControls, (control) => {
        if (!control.isSynced) {
          vm.controls.push(angular.copy(control));
        }
      });
    }

    $scope.$on('refreshSyncControls', (event, opt) => {
      _updateControlList(opt.customerControlId);
    });
    $scope.$on('selectSyncControlChange', () => {
      _handleSyncControlChange();
    });
    vm.filteredAssets = vm.assets;
  }

  function _handleSyncControlChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isSyncSelected === true) {
        selectedIds.push(item.customerControlId);
      }
    }, vm.controls);
    vm.selectAll = selectedIds.length === vm.controls.length;
  }

  function _handleClearFilters() {
    vm.searchText = '';
  }

  function _handleCheckAllChange() {
    R.forEach(
      (control) => {
        control.isSyncSelected = vm.selectAll;
      },
      vm.controls
    );
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleSyncControls($event) {
    const _controls = [];
    R.forEach(
      (control) => {
        if (control.isSyncSelected === true) {
          _controls.push(control);
        }
      },
      vm.controls
    );
    if (_controls.length > 0) {
      ssDialogService.dialogs.controlAdmin.syncControlDialog = ssDialogService.alert(
        syncControlConfirmDialog.getOptions($event, {
          controls: _controls,
          controlType: vm.controlType,
          isMultipleControls: true,
          updateCallBack: _broadcastEvents,
        })
      );

      ssDialogService.show(ssDialogService.dialogs.controlAdmin.syncControlDialog);
    }
  }

  function _broadcastEvents() {
    $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.controlType.customerControlTypeId });
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.syncControlTypeDialog);
  }

  function _updateControlList(existingControlId) {
    angular.forEach(vm.controls, (control, index) => {
      if (existingControlId === control.customerControlId) {
        vm.controls.splice(index, 1);
      }
    });
  }
}

SyncControlTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'ssDialogService',
  'confirmDialog',
  'alerts',
  'controlDataService',
  'loaderService',
  'syncControlConfirmDialog',
];
